import { createIconComponent } from '../../factory/create-icon-component';
export const RomaniaIcon = createIconComponent(
  'RomaniaIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33102)">
      <path d="M23 5H1V19.9995H23V5Z" fill="#FFDA44" />
      <path d="M8.33316 5H1V20H8.33316V5Z" fill="#0052B4" />
      <path d="M22.9998 5H15.6666V20H22.9998V5Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_10086_33102">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
